<template>
  <div class="sidebar">
    <el-menu
      :default-active="activeIndex"
      router
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-menu-item index="/store/home" v-if="checkMenus('/api/store/home/orders/stat@get#')">
        <i class="el-icon-s-home"></i>
        <span slot="title">首页</span>
      </el-menu-item>

      <el-menu-item index="/store/consumer" v-if="checkMenus('/api/store/consumers@get#')">
        <i class="el-icon-s-custom"></i>
        <span slot="title">会员管理</span>
      </el-menu-item>


      <el-submenu index="/orders">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span slot="title">订单管理</span>
        </template>
        <el-menu-item index="/store/orders"  v-if="checkMenus('/api/store/orders@get#')">订单列表</el-menu-item>
        <el-menu-item index="/store/make_queue" v-if="checkMenus('/api/store/make_order_goods_queue@get#')">制作队列</el-menu-item>
        <el-menu-item index="/store/orderGoodsStat" v-if="checkMenus('/api/store/stat/order_goods@get#')">订单菜品统计</el-menu-item>
      </el-submenu>
      <el-submenu index="/goods">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span slot="title">店内管理</span>
        </template>
        <el-menu-item index="/store/queue_up_group"  v-if="checkMenus('/api/store/queue_up/group@get#')">排队管理</el-menu-item>
        <el-menu-item index="/store/goods"  v-if="checkMenus('/api/store/goods@get#')">菜品</el-menu-item>
        <el-menu-item index="/store/goodsGroups" v-if="checkMenus('/api/store/goods_groups@get#')">菜品分组</el-menu-item>
        <el-menu-item index="/store/goodsTag" v-if="checkMenus('/api/store/goods_tag@get#')">菜品标签</el-menu-item>
        <el-menu-item index="/store/tables" v-if="checkMenus('/api/store/tables@get#')">餐桌管理</el-menu-item>
        <el-menu-item index="/store/storeUser" v-if="checkMenus('/api/store/store_user@get#')">店员管理</el-menu-item>
        <el-menu-item index="/store/storeRoles" v-if="checkMenus('/api/store/role@get#')">权限管理</el-menu-item>
      </el-submenu>
      <el-submenu index="/business">
        <template slot="title">
          <i class="el-icon-s-marketing"></i>
          <span slot="title">运营中心</span>
        </template>
        <el-menu-item index="/store/coupons"  v-if="checkMenus('/api/store/coupons@get#')">优惠券</el-menu-item>
      </el-submenu>
      <el-submenu index="/plugins" v-if="user.store.configType == 2">
        <template slot="title">
          <i class="el-icon-goods"></i>
          <!--<i class="el-icon-chat-line-round"></i>-->
          <span slot="title">插件管理</span>
        </template>
        <el-menu-item index="/store/pluginsStore" v-if="checkMenus('/api/store/plugins@get#')">插件市场</el-menu-item>
        <el-menu-item index="/store/h5Config"  v-if="checkMenus('/api/store/h5_config@get#')">H5点餐</el-menu-item>
      </el-submenu>
      <el-submenu index="/app" v-if="pluginMenus && pluginMenus.length > 0">
        <template slot="title">
          <i class="el-icon-box"></i>
          <!--<i class="el-icon-chat-line-round"></i>-->
          <span slot="title">应用管理</span>
        </template>
        <el-menu-item v-for="(item,key) in pluginMenus" :key="key" :index="item.urlPath" v-if="checkMenus(item.apiPath)">{{item.name}}</el-menu-item>
      </el-submenu>



      <!--<el-submenu index="/call">-->
        <!--<template slot="title">-->
          <!--<i class="el-icon-message-solid"></i>-->
          <!--<span slot="title">高级功能</span>-->
        <!--</template>-->
        <!--<el-menu-item index="/store/orderFoodPluginsConfig">功能配置</el-menu-item>-->
        <!--<el-menu-item index="/store/callTag">呼叫配置</el-menu-item>-->
        <!--<el-menu-item index="/store/callLog">呼叫记录</el-menu-item>-->
        <!--<el-menu-item index="/store/chargeItem">充值配置</el-menu-item>-->
      <!--</el-submenu>-->
      <!--<el-submenu index="/printer">-->
        <!--<template slot="title">-->
          <!--<i class="el-icon-printer"></i>-->
          <!--<span slot="title">打印管理</span>-->
        <!--</template>-->
        <!--<el-menu-item index="/store/printerDataModel">打印模板配置</el-menu-item>-->
        <!--<el-menu-item index="/store/printer">打印机管理</el-menu-item>-->
      <!--</el-submenu>-->
      <!--<el-submenu index="/marketing">-->
        <!--<template slot="title">-->
          <!--<i class="el-icon-s-marketing"></i>-->
          <!--<span slot="title">营销管理</span>-->
        <!--</template>-->
      <!--</el-submenu>-->
      <!--<el-menu-item index="/store/pluginsStore" >-->
        <!--<i class="el-icon-goods"></i>-->
        <!--<span slot="title">插件市场</span>-->
      <!--</el-menu-item>-->

      <el-menu-item index="/store/setting"  v-if="user.store.configType == 2">
        <i class="el-icon-setting"></i>
        <span slot="title">系统设置</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Sidebar',
  data () {
    return {
      //configType:1,
      myPermissions:[],
      pluginMenus:[],
      user:{},
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    isCollapse () {
      return !this.sidebar.opened
    },
    activeIndex () {
      const thisRoutPath = this.$route.path
      if (this.$route.name === 'details') {
        return '/tables/details'
      }
      return thisRoutPath
    }
  },
  created(){
    var storage=window.localStorage;
    this.user = JSON.parse(storage["user"]);
    //console.log(user);
    //this.configType = user.store.configType;
    this.initData();
  },
  methods: {
    initData(){
      var that = this;
      that.myPermissions = [];
      that.$api.get('/store/role/permissions', null, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
              var myPermissionsList = res.data.my_permissions;
              myPermissionsList.forEach(function(value,i){
                that.myPermissions.push(value.apiPath);
              });
              console.log(that.myPermissions);
              that.pluginsMenus();
          }else{
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
      });
    },
    pluginsMenus(){
      var that = this;
      that.$api.get('/store/plugins/menus', null, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            that.pluginMenus = res.data.pluginsMenus;
          }else{
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
      });
    },
    checkMenus(per){
      if(this.in_array(per,this.myPermissions)){
        return true;
      }
      return false;
    },
    in_array(search,array){
      for(var i in array){
        if(array[i]==search){
          return true;
        }
      }
      return false;
    },
  }
}
</script>

<style scoped>
  .sidebar {
    background-color: rgb(84, 92, 100);
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 100vh;
    height: 100%;
  }

  .el-menu-vertical-demo {
    min-height: 100vh;
    height: 100%;
  }

  .el-menu-item.is-active,
  .el-submenu.is-active >>> .el-submenu__title {
    background: #484e5c !important;
  }

  .el-submenu .el-menu-item {
    padding-left: 60px !important;
    min-width: auto;
  }
  .el-submenu.is-active .el-menu-item {
    background: #484e5c !important;
  }
  .el-submenu.is-active .el-menu-item.is-active  {
    background: #3a4046 !important;
  }
  .el-submenu .el-menu-item:hover {
    padding-left: 60px !important;
    background: rgb(67, 74, 80) !important;
  }
  .el-menu-item i {
    padding-bottom: 4px;
  }

  .el-submenu__title i {
    padding-bottom: 4px;
  }

  @media all and (max-width: 768px) {
    .el-menu--collapse {
      width: 0;
      overflow: hidden;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/sidebar/StoreSidebar.vue